import React, { useEffect, useState } from 'react';
import '../../styles/About.css'
import axiosPost from '../../helper/axios-helper';

export default function AboutMain() {
  const [ image, setImage ] = useState('');
  const [content] = useState(`
    <b>Who We Are</b><br>
    At CANTO, we connect the Caribbean through innovation and technology, empowering a unified and sustainable gigabit society. 
    As the leading ICT trade association, we drive collaboration, advocate for policy change, and deliver insights that shape the region's digital future.<br><br>
    
    <b>What We Do</b><br>
    We champion digital growth through advocacy, networking, education, and thought leadership—building a connected future where technology works for everyone.<br><br>
    
    <b>Members</b><br>
    Join CANTO today and unlock a world of possibilities! Gain exclusive access to cutting-edge resources, industry intelligence, and a powerful network that's shaping the future of ICT in the Caribbean. 
    Don't just watch the digital revolution—be part of it!
  `);

  useEffect(() => {
    fetchContent()
  }, [])

  const fetchContent = () => {

    axiosPost('content/fetch', {}, {page: 'about'}, (data) => {

      const { success, response } = data;

      if (success) {
        
        setImage(data.data.image)
          

      } else {
          
      }

    })

  }

  return (
    <div>
        <div className='AboutMainHeader' style={{backgroundImage: `url(${image})`}}>
            <div className='about-header-content'>
                
            </div>
        </div>
        <div className='aboutCantoTitle' onClick={() => {console.log(image)}}>
            About CANTO
        </div>
        <div className='AboutCantoInfo'>
          <div dangerouslySetInnerHTML={{ __html: content }} />

        </div>
    </div>
  )
}
